@if (!!data?.length) {
  <div class="flex flex-col gap-2">
    @for (feedback of data; track feedback) {
      <div class="flex w-full flex-col">
        <div app-button class="flex w-full flex-col justify-start! rounded-md bg-white p-1 shadow-md">
          <div class="flex w-full items-center">
            <div (click)="onEdit(feedback)" class="flex w-full items-center justify-start sm:gap-2">
              @if (feedback.type === typeFeedbackEnum.File) {
                <svg-icon class="w-4 text-base-whisper-900" src="assets/icons/icon-clip.svg"></svg-icon>
              } @else {
                <svg-icon class="w-4 text-base-whisper-900" src="assets/icons/icon-page.svg"></svg-icon>
              }

              <p class="mb-1 flex w-full items-center text-base font-medium sm:gap-2">
                {{ feedback.user.name }}:
                <span class="text-left font-normal" translate>
                  {{ feedback.description || 'eclass.subiu-anexo' }}
                </span>
                @if (feedback.type === typeFeedbackEnum.File) {
                  <svg-icon class="w-4" [src]="onGetIcon(feedback)"></svg-icon>
                }
              </p>
            </div>
            <div class="w-6">
              <svg-icon
                (click)="onDelete(feedback)"
                class="min-h-[1rem] min-w-[1rem] text-base-status-danger"
                src="assets/icons/icon-trash.svg"
              ></svg-icon>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
} @else {
  <app-jumbotron class="flex flex-col p-8">
    <p class="text-base" translate>agenda.nenhuma-comentario</p>
    <p class="text-base font-light">
      {{ 'eclass.comentarios-texto' | translate
      }}<svg-icon class="inline-flex h-4 w-4 text-theme-500" src="assets/icons/icon-pencil.svg"></svg-icon
      >{{ 'eclass.comentarios-outros' | translate }} (
      <svg-icon class="inline-flex h-4 w-4 text-theme-500" src="assets/icons/icon-upload-fine.svg"></svg-icon> )
    </p>
  </app-jumbotron>
}
